import { Link, Typography } from '@material-ui/core'
import { useState } from 'react'
import { usePermissions } from 'react-admin'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'

import { TeamLegalBusinessNameChangeDialog } from 'components/Teams/TeamLegalBusinessNameChange'
import { detectEnvironment, Environment } from '../../config/config'
import { OLD_CONSOLE_RESOURCE_MAP } from '../../helpers/constants'
import { hasPermission, Permissions } from '../../Permissions'
import { UserAppPermissions } from '../Users/UserAppPermissions'
import { OldConsoleLink } from './OldConsoleLink'

function Aside({ record, resource }: any) {
  const [showAppPermissions, setShowAppPermissions] = useState(false)
  const { permissions } = usePermissions()
  const [showChangeNameDialog, setShowChangeNameDialog] = useState(false)
  const [newName, setNewName] = useState<string | undefined>(
    resource === 'teams' && record?.name ? record.name : undefined
  )

  const handleModalOpen = () => {
    setNewName(undefined)
    setShowChangeNameDialog(true)
  }

  const handleModalClose = () => {
    setShowChangeNameDialog(false)
    setNewName(undefined)
  }

  if (!record) return null

  const resourceObject = OLD_CONSOLE_RESOURCE_MAP[resource]
  const canSeeAppPermissions =
    permissions && hasPermission(permissions, Permissions.AddPermission) && resource === 'users'
  const env = detectEnvironment()

  function getOrigin() {
    if (env === Environment.DEVELOPMENT) {
      return 'http://localhost:8000'
    }

    return ''
  }

  const oldConsoleUrl =
    getOrigin() +
    '/ct-admin/' +
    resourceObject.resourceString +
    '/' +
    resourceObject.resourceDetailString +
    '/' +
    record.id +
    '/change/'

  return (
    <div style={{ width: 600, margin: '1em' }}>
      {record && (
        <FlexBox gap="40px">
          <OldConsoleLink oldConsoleUrl={oldConsoleUrl} />

          {canSeeAppPermissions && (
            <Typography variant="h6">
              <Link style={{ cursor: 'pointer' }} onClick={() => setShowAppPermissions(true)}>
                App permissions
              </Link>
            </Typography>
          )}
          {resource === 'teams' && (
            <>
              <Typography variant="h6">
                <Link style={{ cursor: 'pointer' }} onClick={() => handleModalOpen()}>
                  Edit team name
                </Link>
              </Typography>
              <TeamLegalBusinessNameChangeDialog
                team={record}
                showDialog={showChangeNameDialog}
                setShowDialog={setShowChangeNameDialog}
                handleClose={handleModalClose}
                inputValue={newName}
                onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => setNewName(event.target.value)}
              />
            </>
          )}
        </FlexBox>
      )}

      {showAppPermissions && (
        <SimpleDialog isOpen onClose={() => setShowAppPermissions(false)}>
          <UserAppPermissions user={record} />
        </SimpleDialog>
      )}
    </div>
  )
}

export default Aside
